<div *ngIf="isLoading | async" class="overlay">
  <mat-spinner class="spinner mat-spinner-color" [diameter]="60"></mat-spinner>
</div>
